<template>
  <div class="augmented-block">
    <div
      v-for="(item, index) in initialdata.textImageCtaBlock"
      :key="index"
      class="image-cta"
      :style="{ background: item.isContentOverlapBG ? '' : item.bgColor }"
    >
      <div
        v-if="!item.isContentOverlapBG && (item.heading || item.subheading || item.title)"
        class="top-content-new"
      >
        <span
          v-if="item.heading"
          class="augmnented-heading"
          :style="{ color: item.headingColor, background: item.headingBgColor }"
          v-html="item.heading"
        ></span>
        <h1 v-if="item.subheading" class="augmnented-subHeading" v-html="item.subheading"></h1>
        <h1 v-if="item.title" class="augmnented-title" v-html="item.title"></h1>
      </div>
      <img
        v-if="!item.isVideo && item.imageSrc != null"
        :src="item.imageSrc"
        :alt="item.imageAlt"
        :style="fullScreenStyle"
      />
      <!-- NOSONAR --><video
        v-if="item.isVideo"
        playsinline
        autoplay
        muted
        loop
        :style="fullScreenStyle"
      >
        <source :src="item.video" type="video/mp4" />
        <source :src="item.video" type="video/ogg" />
      </video>
      <div
        v-if="item.isContentOverlapBG && (item.heading || item.subheading || item.title)"
        class="top-content"
      >
        <span
          v-if="item.heading"
          class="augmnented-heading"
          :style="{ color: item.headingColor, background: item.headingBgColor }"
          v-html="item.heading"
        ></span>
        <h1 v-if="item.subheading" class="augmnented-subHeading" v-html="item.subheading"></h1>
        <h1 v-if="item.title" class="augmnented-title" v-html="item.title"></h1>
      </div>
      <div v-if="item.isContentOverlapBG" class="bottom-content">
        <div v-if="item.isDescription" class="augmneted-down-text" v-html="item.description"></div>
        <a
          v-if="item.ctalink != null"
          :href="item.ctalink"
          class="ripple-animation augmented-cta-button"
          >{{ item.ctalinkText }}</a
        >
      </div>
      <div
        v-else-if="!item.isContentOverlapBG && (item.isDescription || item.ctalink != null)"
        class="bottom-content-new"
      >
        <div v-if="item.isDescription" class="augmneted-down-text" v-html="item.description"></div>
        <a
          v-if="item.ctalink != null"
          :href="item.ctalink"
          class="ripple-animation augmented-cta-button"
          >{{ item.ctalinkText }}</a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'augmented-block',
  props: {
    initialdata: { type: Object, required: true },
  },
};
</script>
